import { useState, useRef, useCallback, memo, useEffect } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../ReduxTool/store/hooks";
import { NewModal } from "../../../Components/New/Modal/NewModal";
import { btnTitleTypeCustomer, ProfileModalOptionsTy } from "../../../Utils/Const";
import { toogleTooltip } from "../../../ReduxTool/Slice/Map/MapReducer";
import { setModalHeaderFooter } from "../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { setRoofDetailsError } from "../../../ReduxTool/Slice/Consumer/ConsumerReducers";
import { saveConsumerProjects } from "../../../ReduxTool/Slice/Consumer/ProjectServices/projectServices";
import NewProfileModal from "./NewProfileModal";
// import UserAddressModal from "./UserAddress";
import { ProfileTy } from "../../../Components/AllInput/types";
import { ParsedCountry } from "react-international-phone";
import { convertImageToBase64, getNumberOfWords, getPasswordErrMsg, handleBase64ToImage, isValidName } from "../../../Utils/commonFunctions";
import { UserDetailsAction } from "../../../ReduxTool/Slice/Auth/asyncHandlers";
import { IconSave } from "../../../assests/icons/MapToolsIcons";
import SecurityPassword from "./SecurityPassword";
import UnitsRegion from "./UnitsRegion";
import UserLanguageModal from "./UserLanguageModal";
import { ModalId } from "../../../Components/New/Modal/ProfileModal/Const";
import { UserAddressModal } from "./UserAddressModal";
import UserProfileModal from "./UserProfileModal";
import PaymentBillingModal from "./PaymentBilling";

const UserProfilePortal = () => {
  const { modal: { modalid,title: modalTitle} } = useAppSelector(state => state.commonReducers)

  return createPortal(
    <>

     {modalid === ModalId.UserAddress && <UserAddressModal />}

     { (modalid === ModalId.UserProfileEditMode || modalid === ModalId.UserProfileEditModeSupport) && <UserProfileModal  /> }

      {modalid === ModalId.UserSecurity && <SecurityPassword/>}
      <UnitsRegion/>
      <UserLanguageModal/>
      <PaymentBillingModal/>
    </>,
    document.getElementById("modal")!
  );
};

export default memo(UserProfilePortal);
